/* Défi d’équipe — objectif non atteint — TC-05 (Bible §52 · v3.2.2 §7 · R3).
   A goal that simply vanishes when missed is worse than no goal: staff read
   silence as a broken promise. So the period closes explicitly, the terms
   declared up front are honoured — nothing is owed — and the framing stays
   factual: no ranking, no named underperformer, no automated encouragement.
   Three exits, all the merchant’s to choose. The closing-days line is a
   stated calculation, labelled as generated, never a judgement (L7). */
import { Button, ErrorState, Note, Tile, Tiles } from '@/ui'
import { useMissedPeriod } from './api'
import { Chargement, Retour } from './parts'

export default function Cloture() {
  const { data, isPending, isError, refetch } = useMissedPeriod()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger la clôture."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  const d = data
  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 760 }}>
      <Retour />
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
        <h2 className="t-page" style={{ margin: 0 }}>Défi d’équipe — {d.label}</h2>
        <span className="f-help" style={{ marginLeft: 'auto' }}>objectif non atteint · période close</span>
      </div>

      <Tiles>
        <Tile label="Objectif" value={d.goal} hint={d.goalUnit} />
        <Tile label="Atteint" value={d.achieved} hint={`${d.achievedPct} % de l’objectif`} />
        <Tile label="Écart" value={d.gap} hint={d.gapNote} />
      </Tiles>

      <Note tone="candour">
        <b>{d.achievedPct} % — et c’est une information, pas une sanction.</b> Le mois est
        clos, rien n’est distribué&nbsp;: les conditions annoncées à l’équipe le disaient.
        Ce qui a été fait reste visible et comptabilisé.
      </Note>

      <Note tone="ok">{d.closingDaysNote}</Note>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Button variant="primary">Reconduire avec un objectif ajusté ({d.adjustedGoal})</Button>
        <Button variant="quiet">Clôturer sans reconduire</Button>
        <Button variant="quiet">Récompenser quand même</Button>
      </div>
    </div>
  )
}
